import { spacer4, spacer8 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { cssColorValue } from "../../styles";
export var Indicator = styled.div.withConfig({
  displayName: "Indicator",
  componentId: "sc-1dk1c5h-0"
})(["display:flex;align-items:center;overflow-wrap:break-word;> *{max-inline-size:100%;}&::before{flex-shrink:0;background-color:", ";block-size:", ";inline-size:", ";border-radius:", ";margin-inline-end:", ";content:'';}"], function (props) {
  return cssColorValue(props.statusColor);
}, spacer8, spacer8, spacer4, spacer8);